import { render } from "./ProductAttributesContainer.vue?vue&type=template&id=af88b528"
import script from "./ProductAttributesContainer.vue?vue&type=script&lang=js"
export * from "./ProductAttributesContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__